import { connect } from 'react-redux'
import ChipUploadComponent from '../components/ChipUploadComponent.jsx';
import { uploadChipData, cleanChipDataAlert } from '../actions';

const mapStateToProps = (state) => ({
  alertStyle: state.getIn(['chipUploadReducer', 'alertStyle']),
  alertMessage: state.getIn(['chipUploadReducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
  uploadFile: (uploadFile) => {
    dispatch(uploadChipData(uploadFile));
  },
  cleanAlert: () => {
    dispatch(cleanChipDataAlert());
  },
})

const ChipUploadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChipUploadComponent)

export default ChipUploadContainer;


// WEBPACK FOOTER //
// ./src/containers/ChipUploadContainer.jsx